import React from 'react'
import { FlowInner, FlowOuter } from './flow.styled'
import { useStepComponent, useStepLayoutComponent } from './flow.utils'

const Flow = React.memo(() => {
  const StepComponent = useStepComponent()
  const StepLayoutComponent = useStepLayoutComponent()

  return (
    <FlowOuter>
      <FlowInner>
        <StepLayoutComponent>
          <StepComponent />
        </StepLayoutComponent>
      </FlowInner>
    </FlowOuter>
  )
})

Flow.displayName = 'FlowComponent'

export default Flow
